const RequestRubleSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="none"><path fill="#fff" d="M10.136 5.992h-1.89v2.277h1.89a1.14 1.14 0 0 0 0-2.277Z"/><path fill="#fff" d="M15.376 2.642a9 9 0 0 0-12.735 0 9 9 0 0 0 0 12.734 9 9 0 0 0 12.735 0 9 9 0 0 0 0-12.734Zm-5.24 7.106h-1.89v.775H9.76a.74.74 0 0 1 0 1.48H8.245v.762a.74.74 0 1 1-1.479 0v-.763h-.763a.74.74 0 1 1 0-1.479h.763v-.775h-.763a.74.74 0 1 1 0-1.479h.763V5.252a.74.74 0 0 1 .74-.74h2.63a2.62 2.62 0 0 1 2.617 2.618 2.62 2.62 0 0 1-2.617 2.618Z"/></svg>
    )
}

export default RequestRubleSvg;